import type { FieldMetaProps } from "formik";
import type React from "react";

export function FieldError({
  meta,
}: { meta: FieldMetaProps<unknown> }): React.ReactElement | null {
  if (!meta.error || !meta.touched) return null;
  if (typeof meta.error !== "string") return null;
  return <p className="mt-1 text-sm text-red-600">{meta.error}</p>;
}
